'use client';

import { Card } from '@app/app/_components/Card/Card';
import { CollapsablePanel } from '@app/app/_components/CollapsablePanel/CollapsablePanel';
import { Select } from '@app/app/_components/Input/Select/Select';
import { VehicleInformation } from '@app/domain/model/eshop/transport/VehicleInformation';
import { VehicleModel } from '@app/domain/model/eshop/transport/VehicleModel';
import { FormState } from '@app/lib/form/contracts/FormState';
import { PurchaseTransportInsuranceResult } from '@app/service/eshop/transport/actions/purchaseTransportInsurance';
import { useTranslations } from 'next-intl';

interface Props {
    vehicleInformation: VehicleInformation;
    vehicleModels: VehicleModel[];
    formState: FormState<PurchaseTransportInsuranceResult>;
}

export function VehicleModelStep({ vehicleInformation, vehicleModels, formState }: Props) {
    const t = useTranslations();

    return (
        <div className="flex flex-col gap-8">
            <Card className="gap-6 p-6">
                <CollapsablePanel
                    label={`${vehicleInformation.make} / ${vehicleInformation.licencePlate}`}
                    collapsable={false}>
                    <div className="p-6">
                        <input type="hidden" name="modelMTPL" value={vehicleInformation.modelMTPL || ''} />
                        <Select
                            name="modelCASCO"
                            label={t('eshop.transport.vehicleModelLabel')}
                            placeholder={t('eshop.transport.vehicleModelPlaceholder')}
                            options={vehicleModels.map(model => ({
                                value: `${model.name}|${model.modificationCode}|${model.deductiblePackageCode}|${model.alarmLevel}`,
                                label: model.name,
                            }))}
                            error={formState.violations?.modelCASCO}
                            defaultValue={formState.data?.formData.modelCASCO}
                            searchable
                        />
                    </div>
                </CollapsablePanel>
            </Card>
        </div>
    );
}
